import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SocialCapitalService } from './social-capital.service';
import { SocialCapitalListComponent } from './social-capital-list.component';

@Component({
    selector: 'app-social-capital-delete',
    templateUrl: './social-capital-delete.component.html',
    styleUrls: ['./social-capital-delete.component.css'],
    standalone: false
})
export class SocialCapitalDeleteComponent {
  
  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public socialCapitalService: SocialCapitalService,
    public dialogRef: MatDialogRef<SocialCapitalListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.socialCapitalService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
